import css from '@css/sass/styles.module.scss';

export interface SvgButtonImages {
  default: string | undefined;
  hover?: string;
  active?: string;
}

export interface SvgToggleButtonOptions {
  parent: HTMLElement;
  id: string;
  images: SvgButtonImages;                    // images de base (non toggled)
  imagesToggled?: SvgButtonImages | null;     // ← rendu optionnel
  floatStyle?: 'left' | 'right' | 'none';
  className?: string;
  initialToggled?: boolean;                   // default: false
  onToggle?: (isToggled: boolean) => void;
  onClick?: () => void;
}

export class SvgToggleButton {
  public element: HTMLImageElement;
  private isToggled: boolean;
  private options: SvgToggleButtonOptions;

  constructor(options: SvgToggleButtonOptions) {
    this.options = {
      floatStyle: 'right',
      initialToggled: false,
      ...options,
    };

    this.isToggled = this.options.initialToggled ?? false;

    this.element = this.createElement();
    this.attachEvents();
    this.updateImage(); // rendu initial
  }

  private createElement(): HTMLImageElement {
    const btn = document.createElement('img');

    btn.id = this.options.id;
    btn.className = `${css.svg_btn}${this.options.className ? ` ${this.options.className}` : ''}`;
    btn.style.float = this.options.floatStyle ?? 'right';
    btn.dataset.dragCancel = 'true'; // empêche le drag

    this.options.parent.appendChild(btn);

    return btn;
  }

  private attachEvents(): void {
    this.element.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.element.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.element.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.element.addEventListener('click', this.onClick.bind(this));
  }

  private getCurrentImages(): SvgButtonImages {
    return this.isToggled && this.options.imagesToggled
      ? this.options.imagesToggled
      : this.options.images;
  }

  private onMouseEnter(): void {
    const curr = this.getCurrentImages();
    if (curr.hover) this.element.src = curr.hover;
  }

  private onMouseLeave(): void {
    this.updateImage();
  }

  private onMouseDown(): void {
    const curr = this.getCurrentImages();
    if (curr.active) this.element.src = curr.active;
  }

  private updateImage(): void {
    const curr = this.getCurrentImages();
    if (curr.default) this.element.src = curr.default;
  }

  private onClick(): void {
    this.toggle();
    this.options.onClick?.();
  }

  // private updateImage(): void {
  //   // On réévalue à chaque fois au cas où imagesToggled serait modifié dynamiquement
  //   const curr = this.isToggled && this.options.imagesToggled
  //     ? this.options.imagesToggled
  //     : this.options.images;

  //   if (curr.default) this.element.src = curr.default;
  // }

  public toggle(): void {
    this.isToggled = !this.isToggled;
    this.updateImage();
    this.options.onToggle?.(this.isToggled);
  }

  public setToggled(isToggled: boolean): void {
    if (isToggled === this.isToggled) return;
    this.isToggled = isToggled;
    this.updateImage();
    this.options.onToggle?.(this.isToggled);
  }

  public getToggled(): boolean {
    return this.isToggled;
  }

  public hide(): void {
    this.element.style.display = 'none';
  }

  public show(): void {
    this.element.style.display = 'block';
  }

  public destroy(): void {
    this.element.remove();
  }
}